import styled from 'styled-components';
import { Row, Col, Space, Divider, Flex } from 'antd';
import { I18n } from 'react-redux-i18n';

import Card from 'components/Card';
import Model from 'modules/Negoce/components/DownloadModels/Models';

const DownloadModelsComponent = styled.div`
  .title {
    font-size: 16px;
    font-family: ${(props) => props.theme.fonts.oswald};
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    color: #f4501c;
    text-transform: uppercase;
  }

  .description {
    font-size: 14px;
    font-family: ${(props) => props.theme.fonts.sfcompact};
  }

  .details {
    font-size: 14px;
    font-family: ${(props) => props.theme.fonts.sfcompact};
    opacity: 0.5;
  }

  .sizeFiles {
    height: 100%;
    min-height: 120px;
  }

  .fileLabel {
    color: #f4501c;
    margin-bottom: 4px;
  }

  .fileName {
    opacity: 0.5;
    font-family: ${(props) => props.theme.fonts.sfcompact};
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    white-space: normal;
  }
`;

const DownloadModels = () => {
  return (
    <DownloadModelsComponent>
      <Card>
        <Row gutter={[16, 16]}>
          <Col md={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 14 }}>
            <Space direction="vertical" size="large">
              <div>
                <h1 className="title">
                  {I18n.t('negoce.submissions.modelFiles.title1')}
                </h1>
                <h1 className="title">
                  {I18n.t('negoce.submissions.modelFiles.title2')}
                </h1>
              </div>
              <div className="description">
                {I18n.t('negoce.submissions.modelFiles.description')}
              </div>
              {/* <p className="details">
                {I18n.t('negoce.submissions.modelFiles.details')}
              </p> */}
            </Space>
          </Col>
          <Col md={{ span: 0 }} lg={{ span: 1 }} xl={{ span: 1 }}>
            <Flex justify="center" style={{ height: '100%' }}>
              <Divider
                style={{ height: '100%', borderInlineStartWidth: 4 }}
                type="vertical"
              />
            </Flex>
          </Col>
          <Col md={{ span: 18 }} lg={{ span: 11 }} xl={{ span: 9 }}>
            <Model />
          </Col>
        </Row>
      </Card>
    </DownloadModelsComponent>
  );
};

export default DownloadModels;
